import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks';
import { PanelDevice } from '../components/PanelDevice';
import { PanelGroup } from '../components/PanelGroup';
import { panelGroups } from '../features/panel_groups/panelGroupsSlice';
import { panelDevicesInGroup } from '../features/panel_devices/panelDevicesSlice';
import { selectEntitiesForPanel } from '../reducers/SelectEntitiesForPanel';
import { subscribeEntities } from '../reducers/entitiesSlice';
export const PanelGroupDevices = (props) => {
    const pds = useAppSelector(state => panelDevicesInGroup(state.definitions.panel_devices, props.panel_group_id));
    const rows = [];
    let outlet_num = 0;
    for (const pt of pds) {
        const key = props.panel_group_id.toString() + '_' + (outlet_num++).toString();
        rows.push(_jsx(PanelDevice, { device_id: pt.device_id }, key));
    }
    return (_jsxs(_Fragment, { children: [" ", rows, " "] }));
};
export const Panel = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const panel_id = id === undefined ? 1 : Number(id); // FIXME
    const entities = useAppSelector((s) => selectEntitiesForPanel(s, panel_id));
    const pgs = useAppSelector(state => panelGroups(state.definitions.panel_groups, panel_id));
    const rows = [];
    useEffect(() => subscribeEntities(dispatch, entities), [entities]);
    for (const group of pgs) {
        rows.push(_jsx(PanelGroup, { name: group.title }, 'h' + group.id));
        rows.push(_jsx(PanelGroupDevices, { panel_group_id: group.id }, 'd' + group.id));
    }
    return (_jsx("div", { className: "page-container panel", children: rows }));
};
